import { css } from '@emotion/css'
import { accessiblyHidden } from '@offerzen/pinata'

const styles = {
  loaderContainer: css({
    display: 'none',
  }),

  loader: css({
    display: 'none',
  }),

  accessiblyHidden: css({
    ...accessiblyHidden,
  }),
}

export default styles
